import React, { useEffect, useState } from "react";
import { Row, Col, Input, Label, Form, FormFeedback } from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import InputCustom from "../../components/Common/InputCustom";
import { addNewArea as onAddNewArea, updateArea as onUpdateArea, deleteArea as onDeleteAera } from "../../store/Areas/actions";
import { getAreas } from "store/Config/actions";


const FormNewArea = props => {

    const dispatch = useDispatch();
    const [isEdit, setIsEdit] = useState(props.isEdit);
    const [isDelete, setIsDelete] = useState(props.isDelete);
    const [areaL, setAreaL] = useState(props.area);

    const[areasList, setAreasList] = useState([]);
    const {  areas = [] } = useSelector(state => ({
        areas: state.ConfigInit.areas || [],
    }));

     useEffect(() => {
         dispatch(getAreas({for_: 'inventory', active: true}));
    }, []);

    useEffect(() => {
        setAreasList(areas);
    }, [areas]);

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            codeKey: (areaL && areaL.code_key) || "",
            name: (areaL && areaL.name) || "",
            titular: (areaL && areaL.titular) || "",
            area: (areaL && areaL.area_id) || "",
            active: (areaL && areaL.active) || "",
        },
        validationSchema: Yup.object({
            codeKey: Yup.string().required("Elige la clave de área"),
            name: Yup.string().required("Elige el día para el horario"),
            //active: Yup.string().required("Elige la hora de término"),
        }),
        onSubmit: (values) => {
            if (isEdit) {
                const updateArea = {
                    id: areaL ? areaL.id : null,
                    codeKey: values["codeKey"],
                    name: values["name"],
                    //active: values["active"],
                    titular: values["titular"],
                    area: values["area"],
                    position: '-',
                    for_: 'inventory',
                    active: areaL.active,
                    pageSize: props?.pagination.pageSize,
                    page: props?.pagination.page
                };
                dispatch(onUpdateArea(updateArea));
                
            } else if(isDelete) {
                const updateArea = {
                    id: areaL ? areaL.id : null,
                    active:true,
                    for_: 'inventory',
                    pageSize: props?.pagination.pageSize,
                    page: props?.pagination.page
                };
                dispatch(onDeleteAera(updateArea));
            } else {
                try {
                const newArea = {
                    codeKey: values["codeKey"],
                    name: values["name"],
                    active: true,
                    titular: values["titular"],
                    area: values["area"],
                    for_: 'inventory',
                    position: '-',
                    pageSize: props?.pagination.pageSize,
                    page: props?.pagination.page
                };
                
                    dispatch(onAddNewArea(newArea));
                } catch (error) {
                    console.error(error)
                }

                //validation.resetForm();
            }
        }
    });

    const handleCheckChange = (e) => {
        setAreaL(prev => ({
            ...prev,
            active: e.target.value === "si" ? true : false
        }))
    }

    useEffect (()=>{
        return () => {  
            validation.resetForm();
            setIsEdit(false)
        }
    },[props?.area, props?.isEdit])

    return (
        <React.Fragment>
            <Form
                onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                }}
            >
                <Row>
                <Col className="col-12">
                    <InputCustom disabled={isDelete}
                            lblInput="Clave de área"
                            inputName="codeKey"
                            inputType="text"
                            inputPlaceholder="Ingrese la clave del área"
                            validation={validation}
                        />                        
                </Col>
                <Col className="col-12">
                        <InputCustom disabled={isDelete}
                            lblInput="Nombre de área"
                            inputName="name"
                            inputType="text"
                            inputPlaceholder="Ingrese el nombre de área"
                            validation={validation}
                        />                        
                </Col>
                <Col className="col-12">
                        <InputCustom disabled={isDelete}
                            lblInput="Nombre del titular(Responsable)"
                            inputName="titular"
                            inputType="text"
                            inputPlaceholder="Ingrese el nombre "
                            validation={validation}
                        />
                </Col>
                <Col className="col-12">                        
                        <div className="mb-3">
                            <Label className="form-label">Sub área</Label>

                            <select className={"form-control"} disabled={isDelete} onChange={validation.handleChange}
                                onBlur={validation.handleBlur} 
                                value={validation.values.area || ""}
                                name={"area"}>
                                <option value={""}>Elige...</option>
                                {
                                    areasList?.map((item, k) => {
                                        return <option key={k} value={item?.id}>{item?.name}</option>
                                    })
                                }
                            </select>
                            
                        </div>
                    </Col>
                    {
                        isDelete && (
                            <div className="mb-3 ">
                                <h3 className=" text-danger">
                                    ¿Está seguro de querer eliminar este registro?
                                </h3>
                            </div>
                        )
                    }

                </Row>
                <Row>
                    <Col>
                        <div className="text-end">
                            <button
                                type="submit"
                                className={`btn save-schedule${isDelete ? ' btn-danger' : ' btn-success'}`}
                            >
                                { isEdit ? "Actualizar" : isDelete ? "Si, Eliminar" : "Guardar"}
                            </button>
                        </div>
                    </Col>
                </Row>
            </Form>
        </React.Fragment>
    )
}

export default FormNewArea